import { Loader2, AlertTriangle } from "lucide-react";

const STATE_COPY = {
  pending: {
    className: "bg-analytics-blue/15 text-analytics-blue border-analytics-blue/30",
    testId: "progress-calc-updating",
  },
  running: {
    className: "bg-analytics-blue/15 text-analytics-blue border-analytics-blue/30",
    testId: "progress-calc-updating",
  },
  failed: {
    className: "bg-analytics-amber/15 text-analytics-amber border-analytics-amber/30",
    testId: "progress-calc-failed",
  },
};

const labelForStatus = (calculationStatus) => {
  const state = calculationStatus?.state;
  if (state === "failed") {
    return "Update failed — previous data is still shown";
  }
  if (calculationStatus?.plan_mode === "full" || calculationStatus?.full_rebuild_required) {
    return "Rebuilding progress history…";
  }
  return "Updating recent progress…";
};

export const ProgressCalculationBanner = ({ calculationStatus }) => {
  const state = calculationStatus?.state;
  if (!state || state === "idle") {
    return null;
  }
  const config = STATE_COPY[state];
  if (!config) {
    return null;
  }
  const Icon = state === "failed" ? AlertTriangle : Loader2;
  const label = labelForStatus(calculationStatus);

  return (
    <div
      className={`mb-4 flex items-center gap-2 border px-3 py-2 text-sm ${config.className}`}
      data-testid={config.testId}
      role="status"
      aria-live="polite"
    >
      <Icon
        className={`h-4 w-4 shrink-0 ${state === "failed" ? "" : "animate-spin"}`}
        aria-hidden="true"
      />
      <span>{label}</span>
    </div>
  );
};
